let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jJwJu")).then(() => parcelRequire('8fHBu'));